import React from 'react';
import PropTypes from 'prop-types';
import APSelect from '../common/APSelect/APSelect';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import './WhiteListedWithdrawAddressSelect.css';
import { required, notDefault } from 'apex-web/lib/helpers/formValidations';

const baseClasses = getBEMClasses('send-address__select');

export default class WhiteListedWithdrawAddressSelect extends React.Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    name: PropTypes.string,
    detailsLink: PropTypes.string,
    hasNoAddresses: PropTypes.bool
  };

  static defaultProps = {
    name: 'ExternalAddress',
    label: 'External Address'
  };

  componentWillMount() {
    this.props.fetchAccountWithdrawInfos();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isLoading && !this.props.isLoading) {
      if (this.props.options.length === 2) {
        const AccountWithdrawInfoId = this.props.options[1].value;

        this.props.resetBankField(AccountWithdrawInfoId);
        this.props.onSelect(AccountWithdrawInfoId);
      }
    }
  }

  render() {
    const { openWhitelistSidepane, positionDetails } = this.props;

    let info;
    //if (this.props.hasNoAddresses) {

    // Always display the option to add a new address, even if there is already
    // one whitelisted address, to allow users to add new addresses more easily
    info = (
      <a
        onClick={() => openWhitelistSidepane(positionDetails)}
        style={{ width: '100%', fontSize: 14 }}>
        Add new address I own
      </a>
    );

    //}

    return (
      <APSelect
        name={this.props.name}
        customClass={baseClasses()}
        label={this.context.t(this.props.label)}
        onSelect={bank => this.props.onSelect(bank)}
        options={this.props.options}
        info={info}
        validate={[required, notDefault]}
      />
    );
  }
}
